import { FileType, Prisma } from "@prisma/client";

export type SignedUrlInfos = {
  signedUrl: string;
  key: string;
};

export type CreateFile = {
  key: string;
  name: string;
  type: FileType;
  isFromTemplate?: boolean;
};

export type PdfTemplateImageRequest = {
  src: string;
};

export type PdfTemplateImage = {
  dataUrl: string;
};

export const fileTypeValues = [
  FileType.media,
  FileType.document,
  FileType.ticket,
  FileType.automated_pdf,
  FileType.deleted_users_files,
  FileType.qr_code,
] as const satisfies Readonly<FileType[]>;

export const fileSelectValues = Prisma.validator<Prisma.FileSelect>()({
  key: true,
  name: true,
  type: true,
});
